import React from "react";
import { Container } from "react-bootstrap";

const WhoThisIsFor = ({ slug, category, header, items }) => {
    if (!items || items.length === 0) return null;

    return (
        <Container className="who-this-is-for" id={slug || "who-this-is-for"}>
            <div className="who-this-is-for__card">
                <div className="who-this-is-for__aside">
                    {category && (
                        <p
                            className="who-this-is-for__label"
                            dangerouslySetInnerHTML={{ __html: category }}
                        />
                    )}
                    {header && (
                        <h2
                            className="who-this-is-for__header"
                            dangerouslySetInnerHTML={{ __html: header }}
                        />
                    )}
                </div>
                <ol className="who-this-is-for__list">
                    {items.map((item, index) => (
                        <li key={index} className="who-this-is-for__item">
                            <span className="who-this-is-for__number">
                                {String(index + 1).padStart(2, "0")}
                            </span>
                            <div>
                                {item.title && (
                                    <h3
                                        className="who-this-is-for__title"
                                        dangerouslySetInnerHTML={{
                                            __html: item.title,
                                        }}
                                    />
                                )}
                                {item.description && (
                                    <div
                                        className="who-this-is-for__description"
                                        dangerouslySetInnerHTML={{
                                            __html: item.description,
                                        }}
                                    />
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </Container>
    );
};

export default WhoThisIsFor;
